import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", null, "User report", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_StServer = _resolveComponent("StServer")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { class: "text-center" }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createVNode(_component_v_row, { class: "px-1 mt-0" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_text_field, {
            loading: _ctx.loading,
            loader: _ctx.loaded,
            color: "primary",
            density: "compact",
            "single-line": "",
            "hide-details": "",
            modelValue: _ctx.userSearch,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userSearch) = $event)),
            label: "Search user",
            placeholder: "User...",
            "prepend-inner-icon": "mdi-account-search",
            "append-inner-icon": "mdi-magnify",
            outlined: "",
            clearable: "",
            solo: "",
            "onClick:appendInner": _ctx.searchAccount,
            onKeydown: _withKeys(_ctx.searchAccount, ["enter"])
          }, {
            loader: _withCtx(() => [
              _createVNode(_component_v_progress_linear, {
                active: _ctx.loading,
                color: 'success',
                absolute: "",
                height: "5",
                indeterminate: ""
              }, null, 8, ["active"])
            ]),
            _: 1
          }, 8, ["loading", "loader", "modelValue", "onClick:appendInner", "onKeydown"])
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_container, {
            "align-center": "",
            "d-flex": "",
            "fill-height": "",
            "grid-list-xs": "",
            id: "id",
            tag: "div",
            wrap: "",
            cols: "12"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fields, (field) => {
                    return (_openBlock(), _createBlock(_resolveDynamicComponent(field.type), {
                      key: field.id,
                      inputData: field.data,
                      title: field.title,
                      color: field.color
                    }, null, 8, ["inputData", "title", "color"]))
                  }), 128))
                ]),
                _: 1
              }),
              (typeof _ctx.stg.status === 'boolean' || typeof _ctx.prd.status === 'boolean')
                ? (_openBlock(), _createBlock(_component_v_row, {
                    key: 0,
                    id: "server-status",
                    tag: "div",
                    wrap: "",
                    class: "font-weight-black bg-blue-lighten-4 my-4"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          (_openBlock(), _createBlock(_component_StServer, {
                            title: 'PRD',
                            "full-title": 'Production',
                            key: 'server-prd',
                            "apis-data": _ctx.prd
                          }, null, 8, ["apis-data"]))
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_v_col, null, {
                        default: _withCtx(() => [
                          (_openBlock(), _createBlock(_component_StServer, {
                            title: 'STG',
                            "full-title": 'Staging',
                            key: 'server-stg',
                            "apis-data": _ctx.stg
                          }, null, 8, ["apis-data"]))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}